
const stats = [{
  value: "10,000+",
  label: "Students Registered"
}, {
  value: "500+",
  label: "Schools Connected"
}, {
  value: "45,000+",
  label: "Services Delivered"
}, {
  value: "4.8/5",
  label: "Average Rating"
}];

const StatsSection = () => {
  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-anyskill-purple mb-2">
                {stat.value}
              </div>
              <div className="text-lg text-muted-foreground">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
